import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { BID_SCHEDULED_STATUS, BID_STATUS, BID_INFO_FILTER_TYPES } from "../../util/bid/bidConstants.js";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "inherit",
    paddingLeft: "2rem",
    paddingRight: "2rem",
  },
  filterToggle: {
    "&:hover": {
      backgroundColor: theme.palette.secondary.swaLightBlue,
    },
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  filterSelected: {
    backgroundColor: theme.palette.secondary.swaLightBlue,
  },
}));

const BidInfoBanner = ({ bids, handleInfoFilter, bidInfoFilter, isAdmin }) => {
  const classes = useStyles();

  const [readyToAwardCount, setReadyToAwardCount] = useState(0);
  const [notScheduledCount, setNotScheduledCount] = useState(0);
  const [openCount, setOpenCount] = useState(0);

  useEffect(() => {
    let readyToAwardCount = 0,
      notScheduledCount = 0,
      openCount = 0;

    bids.forEach((bid) => {
      if (bid.status === BID_STATUS.OPEN) {
        openCount++;
      } else if (bid.status === BID_STATUS.CLOSED) {
        readyToAwardCount++;
      } else if (bid.status === BID_STATUS.PENDING && bid.scheduledStatus === BID_SCHEDULED_STATUS.NOT_SCHEDULED) {
        notScheduledCount++;
      }
    });

    setReadyToAwardCount(readyToAwardCount);
    setNotScheduledCount(notScheduledCount);
    setOpenCount(openCount);
  }, [bids]);

  return (
    <div className={classes.root}>
      <Box
        sx={{
          bgcolor: "secondary.swaLightestBlue",
          width: "100%",
          height: "50px",
          borderTopLeftRadius: "5px",
          borderTopRightRadius: "5px",
          borderTop: "solid 1px",
          borderLeft: "solid 1px",
          borderRight: "solid 1px",
          borderColor: "secondary.swaLightestBlue",
          overflow: "hidden",
        }}
      >
        <Stack
          sx={{ height: "100%", display: "flex", justifyContent: "left", alignItems: "center" }}
          direction="row"
          divider={<Divider sx={{ marginTop: "5px", marginBottom: "5px" }} orientation="vertical" flexItem />}
        >
          <Box
            sx={{
              width: "8vw",
            }}
            onMouseDown={() => handleInfoFilter("")}
            className={`${classes.filterToggle} ${bidInfoFilter === "" && classes.filterSelected}`}
          >
            <Typography component="span" sx={{ textDecoration: "underline" }}>
              {BID_INFO_FILTER_TYPES.ALL_BIDS}
            </Typography>
          </Box>
          {readyToAwardCount > 0 && isAdmin && (
            <Box
              sx={{
                width: "30vw",
              }}
              onMouseDown={() => handleInfoFilter(BID_STATUS.CLOSED)}
              className={`${classes.filterToggle} ${bidInfoFilter === BID_STATUS.CLOSED && classes.filterSelected}`}
            >
              <Typography component="span" sx={{ textDecoration: "underline", paddingLeft: "10px" }}>
                {`${readyToAwardCount} ${BID_INFO_FILTER_TYPES.READY_TO_AWARD}`}
              </Typography>
            </Box>
          )}
          {notScheduledCount > 0 && isAdmin && (
            <Box
              sx={{
                width: "30vw",
              }}
              onMouseDown={() => handleInfoFilter(BID_SCHEDULED_STATUS.NOT_SCHEDULED)}
              className={`${classes.filterToggle} ${
                bidInfoFilter === BID_SCHEDULED_STATUS.NOT_SCHEDULED && classes.filterSelected
              }`}
            >
              <Typography component="span" sx={{ textDecoration: "underline", paddingLeft: "10px" }}>
                {`${notScheduledCount} ${BID_INFO_FILTER_TYPES.NOT_SCHEDULED}`}
              </Typography>
            </Box>
          )}
          {openCount > 0 && (
            <Box
              sx={{
                width: "30vw",
              }}
              onMouseDown={() => handleInfoFilter(BID_STATUS.OPEN)}
              className={`${classes.filterToggle} ${bidInfoFilter === BID_STATUS.OPEN && classes.filterSelected}`}
            >
              <Typography component="span" sx={{ textDecoration: "underline", paddingLeft: "10px" }}>
                {`${openCount} ${BID_INFO_FILTER_TYPES.OPEN}`}
              </Typography>
            </Box>
          )}
        </Stack>
      </Box>
    </div>
  );
};

export default BidInfoBanner;
